
import { Droppable, Draggable } from '@hello-pangea/dnd'
import RenderBoardLink from './RenderBoardLink'
import { FC, ReactNode } from 'react'
import { Box, List } from '@mui/material'

type BoardsTypes = {
  title: string
  _route?: string
  onNavigate?: () => void
  boardTheme: string
  icon: ReactNode
  disabled: boolean
  color?: string
  route?: string
}

interface BoardsNavDraggableProps {
  boards: BoardsTypes[]
  onNavigate: (route: string) => void
}

const BoardsNavDraggable: FC<BoardsNavDraggableProps> = ({ boards, onNavigate }) => {
  return (
    <Droppable droppableId="boards">
      {provided => (
        <List {...provided.droppableProps} ref={provided.innerRef} sx={{ padding: 0 }}>
          {boards.map((board, index) => (
            <Draggable key={board.route} draggableId={board.route} index={index}>
              {(provided, snapshot) => (
                <Box
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  sx={{
                    borderRadius: 2,
                    backgroundColor: snapshot.isDragging ? 'rgba(255,255,255,0.1)' : 'transparent',
                  }}
                >
                  <RenderBoardLink
                    title={board.title}
                    route={board.route}
                    onNavigate={() => onNavigate(board.route)}
                    boardTheme={board.color}
                    icon={board.icon}
                    disabled={board.disabled}
                  />
                </Box>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </List>
      )}
    </Droppable>
  )
}

export default BoardsNavDraggable

// import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd'
// import RenderBoardLink from './RenderBoardLink'
// import { FC, ReactNode } from 'react'
// import { Box, List } from '@mui/material'

// type BoardsTypes = {
//   title: string
//   route: string
//   onNavigate: () => void
//   boardTheme: string
//   icon: ReactNode
//   disabled: boolean
// }
// interface BoardsNavDraggableProps {
//   boards: BoardsTypes
//   onNavigate: () => void
// }

// const BoardsNavDraggable: FC<BoardsNavDraggableProps> = ({ boards, onNavigate }) => {
//   return (
//     <Droppable droppableId="boards">
//       {provided => (
//         <List {...provided.droppableProps} ref={provided.innerRef} sx={{ padding: 0 }}>
//           {boards.map((board, index) => (
//             <Draggable key={board.route} draggableId={board.route} index={index}>
//               {(provided, snapshot) => (
//                 <Box
//                   ref={provided.innerRef}
//                   {...provided.draggableProps}
//                   {...provided.dragHandleProps}
//                   sx={{
//                     // marginBottom: 1,
//                     borderRadius: 2,
//                     backgroundColor: snapshot.isDragging ? 'rgba(255,255,255,0.1)' : 'transparent',
//                   }}
//                 >
//                   <RenderBoardLink
//                     title={board.title}
//                     route={board.route}
//                     onNavigate={onNavigate}
//                     boardTheme={board.color}
//                     icon={board.icon}
//                     disabled={board.disabled}
//                   />
//                 </Box>
//               )}
//             </Draggable>
//           ))}
//           {provided.placeholder}
//         </List>
//       )}
//     </Droppable>
//   )
// }
// export default BoardsNavDraggable
